import React from 'react';
import ProductGroup from '../../../models/ProductGroup';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, Paper, darken } from  '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../../theme/ThemeContext';

export interface Row {
  data: ProductGroup
  action?: 'create' | 'update' | 'error';
}


interface Props {
  rows: Row[];
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  onClickInfo?: (productGroup: ProductGroup) => void;
  onChangePage?: (page: number) => void;
}

const ProductGroups: React.FC<Props> = (props) => {  
  const { t } = useTranslation('product')
  const { theme } = useThemeContext()

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }
  return (
      <Paper style={{borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px"}}>
      { !props.fromIn && <ISTableTitle title={t('groups')}/> }
      <Table style={{whiteSpace:"nowrap", overflow:"hidden"}} size="medium" >
        <TableHead>
          <TableRow selected={true}>
            <ISTableHeaderCell>{t('code')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('description')}</ISTableHeaderCell>
            <ISTableHeaderCell>{t('active')}</ISTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { !props.loading && props.rows.map((row, index) =>
            <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{cursor: 'pointer', backgroundColor: !row.data.active ? darken(theme.palette.action.hover, 0.1) : ''}}
            onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
              <TableCell>{row.data.code}</TableCell>
              <TableCell>{row.data.description}</TableCell>
              <TableCell>{row.data.active ? t('yes') : t('no')}</TableCell>
            </ISTableRow>
          )}
        </TableBody>
      </Table>
      { props.loading &&
        <div style={{display:'flex', justifyContent:'center'}}>
          <CircularProgress size={25} />
        </div>
      }
      <PaginationButtons pagination={props.pagination} />
    </Paper>
  );
}

export default ProductGroups

